import { CONTRACT_STATUS } from '@/common/constant/NormalContractManagementConstant';
import { STATUS_CONTRACT } from '@/common/constant/OrganizationConstant';
import Utils from '@/common/utils/utils';

const handleClickShareStatus = (e, org, setMoreAction, setOpenShareStatusPopover) => {
    setMoreAction(e.currentTarget);
    setOpenShareStatusPopover(org.id);
};

const handleClickExpand = (e, orgId, openGroupPartnerOrSp, setOpenGroupPartnerOrSp) => {
    if (orgId == openGroupPartnerOrSp) {
        return setOpenGroupPartnerOrSp('');
    }

    setOpenGroupPartnerOrSp(orgId);
};

const isDisplayWarningForContractStatus = contractStatus => {
    return [CONTRACT_STATUS.EXPIRED, CONTRACT_STATUS.CANCELLED].includes(contractStatus);
};

const displayContractStatus = contractStatus => {
    return Utils.isEmptyString(contractStatus) ? '' : STATUS_CONTRACT[contractStatus].LABEL_TRIAL;
};

const bgContractStatus = contractStatus => {
    return Utils.isEmptyString(contractStatus) ? 'no-status' : STATUS_CONTRACT[contractStatus].STATUS;
}

export {
    handleClickShareStatus,
    handleClickExpand,
    isDisplayWarningForContractStatus,
    displayContractStatus,
    bgContractStatus
};
